import { Color } from "../Zoning/helpers";
import { DEFAULT_TAXONOMY, ZoningTaxonomy, TaxonomyColors, ZoningColors, ColorGroup } from "../Zoning/types";

export const addTaxonomyColorsAndHotkeys = (raw: any): ZoningTaxonomy => {
  const colorIndex = { text: 0, image: 0, table: 0, math: 0};

  const GetColorGroup = (raw: any, label: string) => {
    let groupKey = (raw[label] in TaxonomyColors ? raw[label] : "image")  as keyof ZoningColors;

    let colorGroup : ColorGroup = {
      groupKey,
      groupColors: TaxonomyColors[groupKey],
      groupColorIndex: colorIndex[groupKey]
    };

    return colorGroup;
  };

  const IncrementColorIndex = (raw: any, label: string) => {
    let colorGroup = GetColorGroup(raw, label); 
    colorIndex[colorGroup.groupKey] = colorGroup.groupColorIndex + 1 < colorGroup.groupColors.length ? colorGroup.groupColorIndex + 1 : 0;
  };

  const GetColor = (raw: any, label: string) => {
    let colorGroup = GetColorGroup(raw, label); 
    return colorGroup.groupColors[colorGroup.groupColorIndex];
  };

  if (typeof raw === "object" && raw !== null && !Array.isArray(raw)) {
    const toReturn: ZoningTaxonomy = {};
    const labels = Object.keys(raw);
    for (const label of labels) {
      let color = new Color(0, 0, 0);
      if (typeof raw[label] === "string") {
        color = GetColor(raw, label);
        IncrementColorIndex(raw, label);
        toReturn[label] = {
          color,
          group: raw[label],
        };
      } else if (
        typeof raw[label] === "object" &&
        raw[label] !== null &&
        !Array.isArray(raw[label])
      ) {
        toReturn[label] = {
          color:
            typeof raw[label].color === "string"
              ? Color.fromString(raw[label].color)
              : new Color(0, 0, 0),
          group: typeof raw[label].group === "string" ? raw[label].group : "",
        };
      } else {
        throw new Error("Invalid taxonomy format.");
      }
    }
    return toReturn;
  }
  return DEFAULT_TAXONOMY;
};
